const MuiList = {
  defaultProps: {},
  styleOverrides: {
    root: ({ theme }) => ({
      "& .MuiDivider-root": {
        borderColor: theme.palette.divider,
        marginTop: theme.spacing(1),
        marginBottom: theme.spacing(1)
      }
    })
  }
};
export {
  MuiList
};
//# sourceMappingURL=MuiList.js.map
